import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { faBars } from '@fortawesome/pro-regular-svg-icons';
import classnames from '../../../utils/classnames.tsx';
import { useLayoutContext } from '../../../contexts/LayoutContext.tsx';
import { withIcon } from '../../Icon.tsx';
import { PageHeaderIconButton } from './PageHeaderButton.tsx';

const MenuIcon = withIcon(faBars);

const PageHeaderNavigationToggle = ({ className }: { className?: string }) => {
    const { t } = useTranslation('core');
    const layout = useLayoutContext();

    if (!layout?.openNavigation) return null;

    return (
        <PageHeaderIconButton
            type="button"
            variant="ghost"
            className={classnames('md:hidden', className)}
            aria-label={t('components.header.openNavigation')}
            onClick={layout.openNavigation}
        >
            <MenuIcon />
        </PageHeaderIconButton>
    );
};

export default PageHeaderNavigationToggle;
